export default {
  user: null,
  accessToken: '',
  refreshToken: '',
  isLoading: false,
};



// WEBPACK FOOTER //
// ./src/config/data.js